import React, { useEffect, useRef, useState } from "react";
import Head from "next/head";
import { BiBath, BiBed, BiLogoWhatsapp } from "react-icons/bi";
import { dbAdmin, rtdbAdmin } from "../../lib/firebase-admin";
import Image from "next/image";
import { getDatabase, ref, child, get, onValue } from "firebase/database";
import { CgProfile } from "react-icons/cg";
// import { FaHouseUser, FaWhatsapp } from "react-icons/fa";

import { rtdb } from "../../scripts/firebase";
import { useAuth } from "../../auth/AuthProvider";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { useAuthModal } from "../../components/auth/modalcontext";
import Link from "next/link";
import * as Dialog from "@radix-ui/react-dialog";
import {
  IoIosArrowBack,
  // IoIosCall
} from "react-icons/io";
import { PiChats } from "react-icons/pi";
import { titleCase } from "../../utils/transform/sentenceCase";
import { useRouter } from "next/router";

// import {
//   FrequentlyBoughtTogether,
//   RelatedProducts,
// } from "@algolia/recommend-react";
// import recommend from "@algolia/recommend";
import useKeypress from "react-use-keypress";
import random from "random";
import Slider from "../../components/UI/toast/Carousel/Slider";

import { getOGimage, getUrl } from "../../utils/getUrl";
import GoogleMap from "google-maps-react-markers";
import moment from "moment";
import { MdOutlineSquareFoot, MdOutlineVilla } from "react-icons/md";
const { BigQuery } = require("@google-cloud/bigquery");
import dynamic from "next/dynamic";
import { IoArrowBackOutline } from "react-icons/io5";
const HomePropertyHit = dynamic(() =>
  import("../../components/search/PlacePropertyHit/HomePropertyHit")
);
const LightBox = dynamic(() =>
  import("../../components/UI/toast/Carousel/lightbox")
);
const UserPropertyChat = dynamic(() =>
  import("../../components/chat/userpropertychat")
);
import { RiSecurePaymentLine } from "react-icons/ri";
import CollapsibleLocation from "../../components/property/collapsible";
import { favoriteProperty } from "../../utils/property/favoriteProperty";
import { capture } from "../../utils/analytics/capture";

// const recommendClient = recommend(
//   process.env.NEXT_PUBLIC_SEARCH_APP_ID,
//   process.env.NEXT_PUBLIC_SEARCH_API_KEY
// );
// const indexName = process.env.NEXT_PUBLIC_PROPERTIES_INDEX;

export async function getStaticPaths() {
  const ref = rtdbAdmin.ref();
  const properties = [];
  const snapshot = await ref.child("Properties").get();
  if (!snapshot.exists()) {
    return "No Properties";
  } else {
    const val = snapshot.val();
    for (const key in val) {
      if (key) {
        const property = val[key];
        const propertyID = key;
        // allTowns.push(property.propertyTown.townSlug);
        properties.push(property);
        properties.push(
          Object.assign(
            {
              propertyID,
            },
            property
          )
        );
      }
    }
  }

  const paths = properties.map((prop) => ({
    params: { property: prop.slugShort },
  }));

  const filteredPaths = paths.filter((p) => p !== "/404" && p !== "/500");
  return { paths: filteredPaths, fallback: "blocking" };
}

export async function getStaticProps({ params }) {
  const propsRef = dbAdmin.collection("Properties");
  const mainRef = rtdbAdmin.ref();

  const snapshot = await propsRef
    .where("slugShort", "==", params.property)
    .where("status", "==", "ACTIVE")
    .limit(1)
    .get();
  if (snapshot.empty) {
    console.log("No matching properties.");
    return {
      notFound: true,
    };
  }
  let property = [];
  snapshot.forEach((doc) => {
    const data = doc.data();
    const propertyID = doc.id;
    property.push(
      Object.assign(
        {
          propertyID,
        },
        data
      )
    );
  });

  if (property[0].status != "ACTIVE") {
    return {
      notFound: true,
    };
  }

  const lister = await mainRef
    .child("Listers")
    .child(property[0].listerID)
    .get();

  const amenities = await mainRef
    .child("PropertyAmenities")
    .child(property[0].propertyID)
    .get();

  const propertyId = property[0].propertyID;

  /// get matching properties
  const monthlyRent =
    property[0].listingType === "RENT"
      ? property[0].monthlyRent
      : property[0].price;
  const lowerLimit = monthlyRent * 0.7; // 30% less than monthlyRent
  const upperLimit = monthlyRent * 1.3; // 30% more than monthlyRent
  const townID = property[0].propertyTown.townID; // assuming propertyTown.townID is the townID
  const snap = await propsRef
    .where("status", "==", "ACTIVE")
    .where("propertyTown.townID", "==", townID)
    .where(
      property[0].listingType === "RENT" ? "monthlyRent" : "price",
      ">=",
      lowerLimit
    )
    .where(
      property[0].listingType === "RENT" ? "monthlyRent" : "price",
      "<=",
      upperLimit
    )
    .limit(5)
    .get();

  let properties = [];
  snap.forEach((doc) => {
    if (doc.id !== propertyId) {
      const data = doc.data();
      const propertyID = doc.id;
      properties.push(
        Object.assign(
          {
            propertyID,
          },
          data
        )
      );
    }
  });

  if (properties.length === 5) {
    properties.pop();
  }

  // console.log(properties.length)

  ///

  /// bigquery
  const bigqueryClient = new BigQuery({
    projectId: process.env.NEXT_PUBLIC_PROJECT_ID,
    credentials: {
      client_email: process.env.FIREBASE_CLIENT_EMAIL,
      private_key: process.env.FIREBASE_PRIVATE_KEY.replace(/\\n/g, "\n"),
    },
  });
  const proj =
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
      ? "ulaafrica"
      : "ula-staging";
  async function runQuery() {
    //     const query = `SELECT
    //     propertyid,
    //     propertyname,
    //     townname,
    //     COUNT(*) AS numberofviews
    //   FROM
    //     \`${proj}.mp_data.mp_master_event\`
    //   WHERE
    //     CAST(time AS DATE) BETWEEN CURRENT_DATE - INTERVAL 6 DAY AND CURRENT_DATE
    //     AND mp_event_name = 'viewed_property_page_touch'
    //     AND propertyid = "${property[0].propertyID}"
    //   GROUP BY
    //     propertyid,
    //     propertyname,
    //     townname;
    // `;
    const query = `SELECT
JSON_VALUE(properties, '$.propertyID') AS propertyid,
JSON_VALUE(properties, '$.propertyName') AS propertyname,
JSON_VALUE(properties, '$.propertyTown.townName') AS townname,
COUNT(*) AS numberofviews
FROM
\`${proj}.phBatchExports.phData\`
WHERE
event = 'browse:page_view'
AND CAST(timestamp AS DATE) BETWEEN CURRENT_DATE - INTERVAL 14 DAY AND CURRENT_DATE
AND JSON_VALUE(properties, '$.propertyID') = "${property[0].propertyID}"
GROUP BY
JSON_VALUE(properties, '$.propertyID'),
JSON_VALUE(properties, '$.propertyName'),
JSON_VALUE(properties, '$.propertyTown.townName');`;

    const options = {
      query: query,
    };
    try {
      // const [rows]=await bigqueryClient.createQueryJob(options);

      // console.log(r)
      const [rows] = await bigqueryClient.query(options);

      // console.log('Results:');
      // rows.forEach((row) => console.log(row));
      return rows[0];
    } catch (error) {
      console.log(error.code);
      console.log(error.errors[0].message);
      throw error;
    }
  }
  // "lead:whatsapp_click"
  async function runQueryWhatsapp() {
    //     const query = `SELECT
    //     propertyid,
    //     propertyname,
    //     townname,
    //     COUNT(*) AS clicks_w
    //   FROM
    //     \`${proj}.mp_data.mp_master_event\`
    //   WHERE
    //     CAST(time AS DATE) BETWEEN CURRENT_DATE - INTERVAL 8 DAY AND CURRENT_DATE
    //     AND mp_event_name = 'clicked_whatsapp'
    //     AND propertyid = "${property[0].propertyID}"
    //   GROUP BY
    //     propertyid,
    //     propertyname,
    //     townname;
    // `;
    const query = `SELECT
JSON_VALUE(properties, '$.propertyID') AS propertyid,
JSON_VALUE(properties, '$.propertyName') AS propertyname,
JSON_VALUE(properties, '$.propertyTown.townName') AS townname,
COUNT(*) AS clicks_w
FROM
\`${proj}.phBatchExports.phData\`
WHERE
event = 'lead:whatsapp_click'
AND CAST(timestamp AS DATE) BETWEEN CURRENT_DATE - INTERVAL 14 DAY AND CURRENT_DATE
AND JSON_VALUE(properties, '$.propertyID') = "${property[0].propertyID}"
GROUP BY
JSON_VALUE(properties, '$.propertyID'),
JSON_VALUE(properties, '$.propertyName'),
JSON_VALUE(properties, '$.propertyTown.townName');`;
    const options = {
      query: query,
    };
    try {
      const [rows] = await bigqueryClient.query(options);
      // console.log(rows[0]);
      return rows[0];
    } catch (error) {
      console.log(error.code);
      console.log(error.errors[0].message);
      throw error;
    }
  }

  let views;
  let whatsappClicks;

  // try {
  //   views = await runQuery();
  // } catch (error) {
  //   console.log(error);
  // }

  // if (views?.numberofviews > 0) {
  //   try {
  //     whatsappClicks = await runQueryWhatsapp();
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  /// end bigquery

  return {
    props: {
      pty: JSON.stringify(property[0]),
      amenty: JSON.stringify(amenities),
      listr: JSON.stringify(lister.val()),
      matchingprops: JSON.stringify(properties),
      vws: views ?? {},
      whatsappClicks: whatsappClicks ?? {},
    },
    revalidate: 10080,
  };
}

function Property({ pty, listr, amenty, matchingprops, vws, whatsappClicks }) {
  // console.log(whatsappClicks);
  const clicks = whatsappClicks.clicks_w;
  const [views, setViews] = useState(vws);
  const [loadingViews, setLoadingViews] = useState(true);
  const [propData, setPropData] = useState(null);
  const [images, setimages] = useState(null);
  const [unfilteredimages, setunfilteredimages] = useState(null);

  const [imagesModalOpen, setImagesModalOpen] = useState(false);
  const [imageLightBoxOpen, setImageLightBoxOpen] = useState(false);

  const [navigation, setNavigation] = useState(true);

  const authModal = useAuthModal();
  // user
  const contextAuth = useAuth();
  const user = contextAuth.user;
  const claims = contextAuth.claims;

  const [favorite, setFavorite] = useState(false);
  const [copiedUrl, setCopiedUrl] = useState(null);
  const [unread, setUnread] = useState(0);
  const [propertyChatVisible, setPropertyChatVisible] = useState(false);
  const [shareModal, setShareModal] = useState(false);

  let property = JSON.parse(pty);
  let lister = JSON.parse(listr) ?? {};
  let amenities = JSON.parse(amenty);
  let matching = JSON.parse(matchingprops);

  const [featureImage, setFeatureImage] = useState(
    property.images
      ? Object.entries(property.images).find((el) => el[1]?.isFeatureImage)
      : null
  );

  function obfuscateGeopoint(lat, lng) {
    // console.log(lat, lng)
    const latitude = lat;
    const longitude = lng;

    const newLatitude = random.uniform(latitude - 0.005, latitude + 0.005);
    const newLongitude = random.uniform(longitude - 0.005, longitude + 0.005);
    return [newLatitude(), newLongitude()];
  }

  useEffect(() => {
    if (user && claims?.user) {
      const dbRef = ref(
        rtdb,
        "Users/" + user.uid + "/PropertyMessages/" + property.propertyID
      );
      const reff = onValue(
        dbRef,
        async (snapshot) => {
          const data = snapshot.val();
          setUnread(data?.unreadCountUser);
        },
        {
          onlyOnce: false,
        }
      );
      return () => reff();
    }
  });
  useEffect(() => {
    setFavorite(user ? property?.savedBy?.includes(user.uid) : false);
  }, [user]);

  useEffect(() => {
    if (views?.numberofviews > 0) {
      fetch(`/api/query/property/views`, {
        method: "POST",
        body: JSON.stringify({
          property: property.propertyID,
        }),
      }).then(async (res) => {
        let r = await res.json();
        setViews(r.message);
        setLoadingViews(false);
        return r;
      });
    }
  }, []);

  useEffect(() => {
    const dbRef = ref(getDatabase());
    get(child(dbRef, `PropertyImages/${property.propertyID}`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          let imags = Object.entries(snapshot.val())
            .filter((el) => !el[1]?.isFeatureImage)
            .sort((a, b) => {
              if (a[1].position > a[1].position) return 1;
              if (a[1].position < b[1].position) return -1;
              return 0;
            });
          let unfilt = Object.entries(snapshot.val()).sort((a, b) => {
            if (a[1].position > a[1].position) return 1;
            if (a[1].position < b[1].position) return -1;
            return 0;
          });
          setimages(imags);
          setunfilteredimages(unfilt);
        } else {
          console.log("No data available");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [images?.length]);

  const titleThree = `${
    (property.noOfBedrooms === 0
      ? property.propertyType
      : property.noOfBedrooms + " bedroom " + property.propertyType) +
    " for " +
    property.listingType.toLowerCase() +
    " in " +
    property.propertyTown.townName +
    ", " +
    property.propertyCounty.countyName +
    " county"
  }`;
  const title = `${
    (property.noOfBedrooms === 0
      ? property.propertyType
      : property.noOfBedrooms + " bedroom " + property.propertyType) +
    " for " +
    property.listingType.toLowerCase() +
    " in " +
    property.propertyTown.townName +
    " " +
    (property.listingType === "RENT"
      ? ` - Kshs ${Intl.NumberFormat().format(property.monthlyRent)}/mo - `
      : ` - Kshs ${Intl.NumberFormat().format(property.price)} - `) +
    // " " +
    // (property.propertyArea.descriptor
    //   ? property.propertyArea.descriptor.toLowerCase()
    //   : " ") +
    // " " +
    property.propertyArea.areaName +
    ", " +
    property.propertyCounty.countyName +
    " county"
  }`;
  const titleTwo = `${
    (property.noOfBedrooms === 0
      ? property.propertyType
      : property.noOfBedrooms + " bedroom " + property.propertyType) +
    " for " +
    property.listingType.toLowerCase() +
    " in " +
    property.propertyTown.townName +
    (property.listingType === "RENT"
      ? ` - Kshs ${Intl.NumberFormat().format(property.monthlyRent)}/mo - `
      : ` - Kshs ${Intl.NumberFormat().format(property.price)} - `) +
    (property.propertyArea.descriptor
      ? property.propertyArea.descriptor.toLowerCase()
      : " ") +
    " " +
    property.propertyArea.areaName +
    ", " +
    property.propertyCounty.countyName
  }`;

  const shareData = {
    title: title,
    text: property.propertyDescription ? property.propertyDescription : "",
    url: `${getUrl()}/homes/${property.slugShort}`,
  };

  const router = useRouter();

  useEffect(() => {
    if (router != null) {
      capture({
        category: "browse",
        event: "page_view",
        properties: {
          ...property,
          page_type: "property",
        },
      });
    }
  }, []);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  let currentImage = unfilteredimages
    ? unfilteredimages[currentImageIndex]
    : null;

  const mySmallImage = useRef(currentImage);

  useKeypress("Escape", () => {
    setImageLightBoxOpen(false);
  });

  const listingSchema = {
    "@type": "RealEstateListing",
    "@id": `${getUrl()}/homes/${property.slugShort}`,
    name: property?.propertyName ?? "",
    description: titleCase(property?.propertyDescription?.substring(0, 160)),
    image: Object.entries(property.images).map((image) => {
      return image[1].url;
    }),
    url: `${getUrl()}/homes/${property.slugShort}`,
    datePosted: moment(property?.inputData?.addedTime?.time).format(
      "YYYY-MM-DD"
    ),
    offers: {
      "@type": "Offer",
      priceCurrency: "KES",
      price:
        property?.listingType === "RENT"
          ? property?.monthlyRent
          : property?.price,
      availability: "http://schema.org/InStock",
      validFrom: moment(property?.inputData?.addedTime?.time).format(
        "YYYY-MM-DD"
      ),
      category: property?.listingType === "RENT" ? "For Rent" : "For Sale",
      // leaseLength: 6,
    },
  };

  const schemaData =
    property?.noOfBedrooms >= 2
      ? {
          "@context": "https://schema.org",
          "@type": "SingleFamilyResidence",
          name: property?.propertyName ?? "",
          description: titleCase(
            property?.propertyDescription?.substring(0, 160)
          ),
          image: featureImage ? featureImage[1].url : "",
          numberOfRooms: property.noOfBedrooms + property.noOfBathrooms + 1,
          occupancy: {
            "@type": "QuantitativeValue",
            minValue: 1,
            maxValue: property?.noOfBedrooms + 1,
          },
          floorSize: {
            "@type": "QuantitativeValue",
            value: property?.squareFootage ?? 0,
            unitCode: "FTK",
          },

          leaseLength: {
            "@type": "QuantitativeValue",
            value: 24,
            unitText: "months",
          },
          numberOfBathroomsTotal: property?.noOfBathrooms,
          numberOfBedrooms: property?.noOfBedrooms,
          permittedUsage: "Perfectly suitable for a family with two kids.",
          // petsAllowed: "Only cats are allowed",
          // yearBuilt: 1988,
          address: {
            "@type": "PostalAddress",
            contactType: "Address",
            addressCountry: "KE",
            addressLocality: property?.propertyCounty.countyName,
            addressRegion: property?.propertyTown.townName,
            postalCode:
              property?.propertyArea?.address_components[0].types.includes(
                "plus_code"
              )
                ? property?.propertyArea?.address_components[0].short_name
                : "",
            streetAddress:
              !property?.propertyArea?.address_components[0].types.includes(
                "plus_code"
              )
                ? property?.propertyArea?.address_components[0].long_name
                : property.propertyArea?.areaName.substring(
                    0,
                    property?.propertyArea?.areaName.indexOf(",")
                  ),
          },
          telephone: `+254${lister.listerInfo.listerPhone}`,
        }
      : {
          "@context": "https://schema.org",
          "@type": "House",
          "@id": "House",
          // yearBuilt: "2023",
          telephone: `+254${lister.listerInfo.listerPhone}`,
          // numberOfRooms: "1",
          numberOfBedrooms: property?.noOfBedrooms,
          numberOfBathroomsTotal: property?.noOfBathrooms,
          name: property?.propertyName ?? "",
          latitude: property?.addressHidden
            ? obfuscateGeopoint(
                property?.propertyExactLocation.geoPoint._latitude,
                property?.propertyExactLocation.geoPoint._longitude
              )[0]
            : property?.propertyExactLocation.geoPoint._latitude,
          longitude: property?.addressHidden
            ? obfuscateGeopoint(
                property?.propertyExactLocation?.geoPoint._latitude,
                property?.propertyExactLocation?.geoPoint._longitude
              )[1]
            : property?.propertyExactLocation.geoPoint._longitude,
          image: featureImage ? featureImage[1].url : "",
          address: `${
            !property?.propertyArea?.address_components[0].types.includes(
              "plus_code"
            )
              ? property?.propertyArea?.address_components[0].long_name
              : property.propertyArea?.areaName.substring(
                  0,
                  property?.propertyArea?.areaName.indexOf(",")
                )
          }
          , ${property?.propertyTown.townName},
          ${property?.propertyCounty.countyName}`,
        };

  const mapRef = useRef(null);
  const [mapReady, setMapReady] = useState(false);
  const [nearby, setNearby] = useState(property?.nearby ?? null);

  const service = useRef(null);
  const distance = useRef(null);
  // let service;
  // let distance;

  const onGoogleApiLoaded = ({ map, maps }) => {
    mapRef.current = map;
    map.setOptions({
      mapId: process.env.NEXT_PUBLIC_MAP_ID,
      gestureHandling: "greedy",
      zoomControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
    });
    service.current = new google.maps.places.PlacesService(map);
    distance.current = new google.maps.DistanceMatrixService();

    setMapReady(true);
  };

  const onMarkerClick = (property) => {
    mapRef.current.setCenter({
      lat: property.propertyExactLocation._geoloc.lat,
      lng: property.propertyExactLocation._geoloc.lng,
    });
    // mapRef.current.
    // rif. https://developers.google.com/maps/documentation/javascript/reference
  };

  const PinComponent = ({ text, onClick }) => {
    let property = JSON.parse(text);
    return (
      <div
        onClick={() => {
          // onClick(property);
        }}
        className=" group flex  min-w-max  flex-col items-center"
      >
        <div className=" flex h-10 w-full cursor-pointer items-center justify-center rounded-md border border-zote-secondary bg-zote-background-light px-4  text-center text-zote-secondary shadow-md  transition-all duration-200 group-hover:scale-105 ">
          <span className=" cursor-pointer text-sm font-semibold ">
            {property.propertyName
              ? property.propertyName
              : property.noOfBedrooms === 0
              ? `${property.propertyType} in ${property.propertyTown?.townName}`
              : `${property.noOfBedrooms} bedroom ${property.propertyType}, ${property.propertyTown?.townName}`}
          </span>
        </div>
        {/* {!property.addressHidden ? (
          <BiSolidDownArrow className=" -mt-[0.20rem] h-3 w-3 text-zote-primary transition-all      duration-200 group-hover:scale-105" />
        ) : null} */}
      </div>
    );
  };

  const [loadingProperty, setLoadingProperty] = useState(null);

  const breadSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        item: {
          "@type": "Webpage",
          "@id": `${getUrl()}`,
          name: "Zote",
          url: `${getUrl()}`,
        },
      },
      {
        "@type": "ListItem",
        position: 2,
        item: {
          "@type": "WebPage",
          "@id": `${getUrl()}/homes`,
          name: `Find available houses for rent and sale in Nairobi`,
          url: `${getUrl()}/homes`,
        },
      },
      {
        "@type": "ListItem",
        position: 3,
        item: {
          "@type": "RealEstateListing",
          "@id": `${getUrl()}/homes/${property.slugShort}`,
          name: property.propertyDescription
            ? titleCase(property.propertyDescription.substring(0, 155))
            : "",
          url: `${getUrl()}/homes/${property.slugShort}`,
          image: `${featureImage ? featureImage[1].url : `${getOGimage()}`}`,
        },
      },
    ],
  };

  // Define the property details
  const propertyChat = {
    phone: `+${process.env.NEXT_PUBLIC_WA_SOURCE_NUMBER}`,
    reference: property.propertyID,
    type: property.propertyType,
    price:
      property.listingType === "RENT"
        ? Intl.NumberFormat().format(property.monthlyRent)
        : Intl.NumberFormat().format(property.price),
    location: property.propertyTown.townName,
    link: `${getUrl()}/homes/${property.slugShort}`,
  };

  // console.log(lister.listerInfo.listerName);
  const listerName = lister.listerInfo.listerName;

  // Define the message template
  let message;

  if (listerName === "Zote") {
    message = `Hello, I would like to get more information about this house

Reference: ${propertyChat.reference}
Type: ${propertyChat.type}
Price: Kshs ${
      propertyChat.price + (property.listingType === "RENT" ? "/mo" : "")
    }
Town: ${propertyChat.location}
Property: ${propertyChat.link}
  
Any changes made to this message will result in the enquiry not being sent to your assigned agent.`;
  } else {
    message = `Hello, I would like to get more information about this house you posted on zote.africa

Reference: ${propertyChat.reference}
Type: ${propertyChat.type}
Price: Kshs ${
      propertyChat.price + (property.listingType === "RENT" ? "/mo" : "")
    }
Town: ${propertyChat.location}
Property: ${propertyChat.link}
  
Any changes made to this message will result in the enquiry not being sent to the agent.`;
  }

  // URL encode the message
  const encodedMessage = encodeURIComponent(message);

  // Create the WhatsApp Click to Chat URL
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${propertyChat.phone}&text=${encodedMessage}`;

  const addedWeeks = moment().diff(
    moment.unix(property?.inputData?.addedTime?._seconds).format("YYYY-MM-DD"),
    "weeks"
  );

  // console.log(addedWeeks);

  return (
    <>
      <Head>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta charSet="utf-8" />
        <title>{titleCase(`${title}`)}</title>
        <meta property="og:title" content={titleCase(`${title}`)} />
        <meta
          name="description"
          content={
            property.propertyDescription
              ? titleCase(property.propertyDescription.substring(0, 155))
              : ""
          }
        />
        <meta
          property="og:description"
          content={`${titleCase(
            property.propertyDescription.substring(0, 155)
          )}`}
        />
        <meta
          property="og:url"
          content={`${getUrl()}/homes/${property.slugShort}`}
        />
        <meta
          property="og:image"
          name="og:image"
          content={`${featureImage ? featureImage[1].url : `${getOGimage()}`}`}
        />

        <link
          rel="canonical"
          href={`${getUrl()}/homes/${property.slugShort}`}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(listingSchema) }}
        />
        <meta name="twitter:card" content="summary_large_image" />
        {/* <meta name="twitter:site" content="@di" /> */}
        <meta name="twitter:title" content={titleCase(`${title}`)} />
        {/* <meta
          name="twitter:description"
          content={`${titleCase(
            property.propertyDescription.substring(0, 155)
          )}`}
        /> */}
        <meta
          name="twitter:image"
          content={`${featureImage ? featureImage[1].url : ""}`}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadSchema) }}
        />
      </Head>

      <div className=" h-auto w-full px-0 py-0 lg:px-24 lg:pb-1 lg:pt-4">
        <div className="scrollbar-hide flex w-full flex-row items-center space-x-1 overflow-x-auto  py-3 pl-1 pr-8 lg:space-x-1 lg:px-0 lg:py-0 lg:pl-0">
          {/* <Link href="/" passHref>
            <AiFillHome className=" flex h-4 w-4 flex-shrink-0 cursor-pointer  text-zote-primary  hover:text-zote-primary" />
          </Link> */}
          {/* <MdArrowForwardIos className="flex h-3 w-3 flex-shrink-0  text-zote-primary" /> */}
          <Link href={`/town/${property.propertyTown.townSlug}`} passHref>
            <a className=" group flex  flex-shrink-0 flex-row items-center space-x-1 rounded-md px-2 py-1 hover:bg-blue-50 ">
              <IoArrowBackOutline className=" flex h-4 w-4 flex-shrink-0 cursor-pointer  text-zote-primary  hover:text-zote-primary" />
              <h2 className=" flex  select-none overflow-x-clip text-ellipsis text-sm text-zote-primary  hover:text-zote-primary ">
                Back to {property?.propertyTown.townName}
              </h2>
            </a>
          </Link>
          <span className="  text-gray-500">|</span>
          {/* <MdArrowForwardIos className="flex h-3 w-3 flex-shrink-0  text-zote-primary" /> */}
          <h1 className=" flex flex-shrink-0 select-none pr-5 text-sm text-gray-600 ">
            {title}
          </h1>
        </div>

        <div className="relative hidden h-[60vh] flex-row space-x-2 pt-3 lg:flex ">
          <div className=" relative flex w-1/2 items-center justify-center rounded-l-md bg-gray-100 ">
            <MdOutlineVilla className=" absolute h-12 w-12 animate-pulse text-gray-500" />
            {images != null ? (
              <Image
                onClick={() => {
                  setImagesModalOpen(true);
                }}
                priority
                unoptimized
                key={images ? unfilteredimages[0][1].url : ""}
                //key={uuidv4()}
                //key={titleTwo + " - main property image"}
                className=" transition:brightness cursor-pointer rounded-l-md object-cover transition-all duration-300 ease-in-out hover:brightness-90"
                layout="fill"
                alt={titleTwo + " - main property image"}
                // title={titleTwo + " - main property image"}
                src={images ? unfilteredimages[0][1].url : ""}
              />
            ) : null}
          </div>
          <div className=" grid  w-1/2 grid-cols-2 gap-2 rounded-r-md">
            <div className=" relative  flex w-full flex-shrink-0 items-center justify-center bg-gray-100">
              <MdOutlineVilla className=" absolute h-12 w-12 animate-pulse text-gray-500" />

              {images != null ? (
                <Image
                  unoptimized
                  priority
                  //key={titleTwo + " - property image 2"}
                  key={images ? images[1][1].url : ""}
                  //key={uuidv4()}
                  onClick={() => {
                    setImagesModalOpen(true);
                  }}
                  alt={titleTwo + " - property image 2"}
                  // title={titleTwo + " - property image 2"}
                  className=" transition:brightness  cursor-pointer object-cover duration-300 hover:brightness-90"
                  layout="fill"
                  src={images ? images[1][1].url : ""}
                />
              ) : null}
            </div>
            <div className="  relative flex w-full flex-shrink-0 items-center justify-center rounded-tr-md bg-gray-100">
              <MdOutlineVilla className=" absolute h-12 w-12 animate-pulse text-gray-500" />
              {images != null ? (
                <Image
                  priority
                  unoptimized
                  onClick={() => {
                    setImagesModalOpen(true);
                  }}
                  // key={titleTwo + " - property image 3"}
                  key={images ? images[2][1].url : ""}
                  //key={uuidv4()}
                  className=" transition:brightness  cursor-pointer rounded-tr-md object-cover duration-300 hover:brightness-90"
                  layout="fill"
                  alt={titleTwo + " - property image 3"}
                  // title={titleTwo + " - property image 3"}
                  src={images ? images[2][1].url : ""}
                />
              ) : null}
            </div>
            <div className=" relative  flex w-full items-center justify-center bg-gray-100">
              <MdOutlineVilla className=" absolute h-12 w-12 animate-pulse text-gray-500" />
              {images != null ? (
                <Image
                  priority
                  unoptimized
                  // key={titleTwo + " - property image 4"}
                  key={images ? (images[3] ? images[3][1].url : "") : ""}
                  // key={uuidv4()}
                  onClick={() => {
                    setImagesModalOpen(true);
                  }}
                  alt={titleTwo + " - property image 4"}
                  // title={titleTwo + " - property image 4"}
                  className=" transition:brightness cursor-pointer object-cover duration-300 hover:brightness-90 "
                  layout="fill"
                  src={images ? (images[3] ? images[3][1].url : "") : ""}
                />
              ) : null}
            </div>
            <div className=" relative flex w-full  flex-shrink-0 items-center justify-center rounded-br-md bg-gray-100">
              <MdOutlineVilla className=" absolute h-12 w-12 animate-pulse text-gray-500 " />
              {images != null ? (
                <Image
                  priority
                  unoptimized
                  // key={titleTwo + " - property image 5"}
                  key={images ? images[4][1].url : ""}
                  //key={uuidv4()}
                  onClick={() => {
                    setImagesModalOpen(true);
                  }}
                  alt={titleTwo + " - property image 5"}
                  // title={titleTwo + " - property image 5"}
                  className=" transition:brightness  cursor-pointer rounded-br-md object-cover duration-300 hover:brightness-90"
                  layout="fill"
                  src={images ? images[4][1].url : ""}
                />
              ) : null}
            </div>

            <a
              href=""
              // href="javascript:void(0)"
              onClick={(e) => {
                e.preventDefault();
                setImagesModalOpen(true);
              }}
              className=" absolute bottom-0  right-0 mb-4 mr-4 hidden cursor-pointer items-center justify-center rounded-md border border-gray-800 bg-white px-5 py-1 lg:flex"
            >
              <span className="text-sm font-medium">View all photos</span>
            </a>
          </div>
        </div>
        <div className="  relative flex h-56 w-full  items-center justify-center rounded-none  lg:hidden lg:h-[35vh] ">
          <Slider
            propertyImages={property.images}
            propertyData={property}
            source="MAIN-PROPERTY"
            loadingProperty={false}
            setLoadingProperty={null}
            edit={null}
            type={null}
            setImagesModalOpen={setImagesModalOpen}
          />

          {/* <div className=" absolute bottom-0 left-0 mb-2 ml-3 flex lg:hidden flex-row space-x-1 items-center ">
						<BiCamera className=" stroke-current text-gray-800" />
						<span className=" font-medium text-sm text-gray-800">
							1/25
						</span>
					</div> */}
          <div
            className={
              "absolute right-0   top-0  mr-3 mt-2 flex h-auto  flex-row items-center space-x-4 lg:hidden lg:space-x-4 " +
              (imageLightBoxOpen || imagesModalOpen ? "z-0" : " z-10")
            }
          >
            <div
              onClick={() => setShareModal(true)}
              className=" flex cursor-pointer flex-row  items-center rounded-full bg-white px-2 py-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-share-2"
              >
                <circle cx="18" cy="5" r="3" />
                <circle cx="6" cy="12" r="3" />
                <circle cx="18" cy="19" r="3" />
                <path d="M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98" />
              </svg>
            </div>
            <div
              onClick={async () => {
                if (!user) {
                  authModal.setOpen(true);
                  authModal.setActive(1);
                  authModal.setActionMode("SAVE");

                  capture({
                    category: "browse",
                    event: "favorite_click",
                  });
                  return;
                }
                if (user && claims.manager) {
                  capture({
                    type: "lister",
                    category: "browse",
                    event: "favorite_click",
                  });
                  return;
                }

                await favoriteProperty(
                  user,
                  claims,
                  favorite,
                  setFavorite,
                  property,
                  "FIRESTORE"
                );
              }}
              className={
                "flex cursor-pointer flex-row  items-center rounded-full border-0 border-red-200 bg-white  p-2 shadow-sm" +
                (favorite ? " bg-red-50" : "")
              }
            >
              {!favorite ? (
                <AiOutlineHeart className="h-4 w-4 group-hover:text-red-500" />
              ) : (
                <AiFillHeart className=" h-4 w-4 text-red-500 " />
              )}
            </div>
          </div>
        </div>
      </div>

      <Dialog.Root open={imagesModalOpen}>
        <Dialog.Trigger />
        <Dialog.Portal>
          <Dialog.Overlay />
          <Dialog.Content>
            <Dialog.Title />
            <Dialog.Description />
            <Dialog.Close />
            <div className=" fixed top-0 z-20  h-screen w-full space-y-4  overflow-y-auto  bg-white  py-4 lg:space-y-6 lg:py-12 ">
              <div className=" sticky top-0 z-10 px-5 lg:px-16">
                <a
                  href=""
                  //  href="javascript:void(0)"
                  onClick={(e) => {
                    e.preventDefault();
                    setImagesModalOpen(false);
                  }}
                  className="  flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-gray-200 lg:h-10 lg:w-10"
                >
                  <IoIosArrowBack className=" h-5 w-5 " />
                </a>
              </div>
              <div className=" grid grid-cols-1 gap-3 px-0 lg:grid-cols-3 lg:gap-5 lg:px-32">
                {unfilteredimages?.map((el, i) => {
                  return (
                    <div
                      onClick={() => {
                        setImageLightBoxOpen(true);
                        setCurrentImageIndex(i);
                      }}
                      key={el[0]}
                      className=" transition:brightness relative flex h-48 flex-shrink-0 items-center justify-center border border-gray-200 bg-gray-150 duration-300 hover:brightness-75 lg:h-72 lg:rounded-md"
                    >
                      <MdOutlineVilla className=" absolute h-12 w-12 animate-pulse text-gray-500 " />
                      <Image
                        unoptimized
                        alt={
                          titleTwo +
                          (i === 0
                            ? " - main property image"
                            : " - property image " + (i + 1))
                        }
                        // key={uuidv4()}
                        onError={(err) => {
                          console.log(err);
                        }}
                        key={el[1]?.url}
                        src={el[1]?.url}
                        className=" h-full w-full  cursor-pointer object-cover lg:rounded"
                        layout="fill"
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>

      {imageLightBoxOpen ? (
        <LightBox
          imageLightBoxOpen={imageLightBoxOpen}
          mySmallImage={mySmallImage}
          currentImageIndex={currentImageIndex}
          setCurrentImageIndex={setCurrentImageIndex}
          unfilteredimages={unfilteredimages}
          currentImage={currentImage}
          setImageLightBoxOpen={setImageLightBoxOpen}
          navigation={true}
          propertyData={property}
        />
      ) : null}

      <div className=" h-auto w-full px-4  py-0 lg:px-24 lg:py-0">
        <div className=" flex flex-col items-start  justify-between lg:mb-4  lg:flex-row">
          <h2 className=" text-sm uppercase text-gray-700  lg:text-base">
            {titleThree}
          </h2>
          {/* <div className=" mt-0 flex w-56 flex-col rounded-md bg-blue-100 px-5 py-3">
            <span>2 views in the past week</span>
          </div> */}
        </div>
        {property.market === "OFF-MARKET" ? (
          <span className="  my-2 flex flex-wrap rounded-md border border-gray-200 bg-gray-100 px-4 py-3 shadow-md lg:hidden">
            This property is not available.{" "}
            <Link href={`/town/${property.propertyTown.townSlug}`} passHref>
              <a className="  cursor-pointer font-medium text-zote-primary hover:underline">
                See more available homes in {property.propertyTown.townName}
              </a>
            </Link>
          </span>
        ) : null}
        <div className=" mt-1 h-auto w-full py-0">
          <div className="relative flex flex-row items-center  space-x-3 lg:items-center lg:space-x-8">
            {property.listingType === "RENT" ? (
              <span className=" text-xl font-semibold tracking-normal text-gray-900 lg:text-2xl">
                Kshs {Intl.NumberFormat().format(property.monthlyRent)}
              </span>
            ) : (
              <span className=" text-xl font-semibold tracking-normal text-gray-900 lg:text-2xl">
                Kshs {Intl.NumberFormat().format(property.price)}
              </span>
            )}

            <div className=" flex flex-row items-center space-x-3">
              {property.listingType === "RENT" ? (
                <span className=" mt-1 flex flex-shrink-0  cursor-default rounded-full border-0 border-blue-200 bg-teal-100 px-3 py-1 text-center text-xs font-medium text-teal-700 lg:mt-0 lg:px-5  lg:text-sm">
                  For rent
                </span>
              ) : (
                <span className=" mt-1 flex flex-shrink-0  cursor-default rounded-full border-0 border-purple-100 bg-lightblue-100 px-3 py-1 text-center text-xs font-medium text-lightblue-700 lg:mt-0 lg:px-5  lg:text-sm">
                  For sale
                </span>
              )}
              {property.market === "OFF-MARKET" ? (
                <span className="   top-0 cursor-default rounded-full bg-yellow-700 px-4 py-2 text-xs font-semibold text-yellow-100">
                  {"Off Market"}
                </span>
              ) : null}
              {addedWeeks < 5 ? (
                <span className="   top-0 rounded-full bg-purple-700 px-4 py-1 text-xs font-semibold uppercase text-gray-150">
                  Added recently
                </span>
              ) : null}
            </div>
            {property.market === "OFF-MARKET" ? (
              <span className=" hidden rounded-md border border-gray-200 bg-gray-100 px-5 py-3 shadow-md lg:flex">
                This property is not available.{" "}
                <Link href={`/town/${property.propertyTown.townSlug}`} passHref>
                  <a className=" ml-1 cursor-pointer font-medium text-zote-primary hover:underline">
                    See more available homes in {property.propertyTown.townName}
                  </a>
                </Link>
              </span>
            ) : null}
          </div>

          <div className=" relative flex h-auto w-full flex-row">
            <div className=" flex flex-col space-y-0">
              {property.propertyName ? (
                <h2 className=" text-gray-800 lg:text-lg">
                  {property.propertyName ?? ""}
                </h2>
              ) : null}
              {/* <h1 className=" hidden ">{title}</h1> */}
              <span className="  flex flex-row text-base  text-gray-700  no-underline lg:text-base lg:text-gray-800">
                {!property.propertyArea?.address_components[0].types.includes(
                  "plus_code"
                )
                  ? property.propertyArea?.address_components[0].long_name
                  : property.propertyArea?.areaName.substring(
                      0,
                      property.propertyArea?.areaName.indexOf(",")
                    )}
                ,{" "}
                <Link href={`/town/${property.propertyTown.townSlug}`} passHref>
                  <a className=" ml-1 cursor-pointer">
                    {" "}
                    {property.propertyTown.townName}
                  </a>
                </Link>
                , {property.propertyCounty.countyName}
              </span>
              {/* for SEO Hierarchy, not visible */}

              {property.listingType === "RENT" ? (
                <h3 className=" hidden text-xl font-semibold tracking-normal text-gray-900 lg:text-2xl">
                  Kshs {Intl.NumberFormat().format(property.monthlyRent)}
                </h3>
              ) : (
                <h3 className=" hidden text-xl font-semibold tracking-normal text-gray-900 lg:text-2xl">
                  Kshs {Intl.NumberFormat().format(property.price)}
                </h3>
              )}

              {/* for SEO Hierarchy, not visible */}

              {/* <span className="">1 bedroom 2 bathrooms</span> */}
            </div>
            <Dialog.Root open={shareModal} modal>
              <Dialog.Trigger />
              <Dialog.Portal>
                <Dialog.Overlay
                  onClick={() => {
                    setShareModal(false);
                    setCopiedUrl(null);
                  }}
                  className="fixed inset-0 z-20  flex h-screen flex-col items-center justify-center bg-black  opacity-50 "
                />
                <Dialog.Content>
                  {/* <Dialog.Title />
        <Dialog.Description />
        <Dialog.Close /> */}
                  <div
                    onClick={() => {
                      // setShareModal(false)
                    }}
                    className="  fixed left-[35vw] top-[35vh]  z-30 flex flex-col space-y-4 rounded-md border border-gray-200 bg-white px-6 py-6 lg:left-[45vw] "
                  >
                    <span className=" font-medium">Share Property</span>
                    <div className="">
                      {copiedUrl ? (
                        <button
                          onClick={() => {
                            navigator.clipboard
                              .writeText(
                                `${getUrl()}/homes/${property.slugShort}`
                              )
                              .then(() => {
                                setCopiedUrl(
                                  `${getUrl()}/homes/${property.slugShort}`
                                );
                                capture({
                                  category: "browse",
                                  event: "share_done",
                                  properties: property,
                                });
                              });
                          }}
                          className="w-full rounded-md bg-zote-primary px-5 py-2 font-medium text-white"
                        >
                          Copied!
                        </button>
                      ) : (
                        <button
                          onClick={() => {
                            navigator.clipboard
                              .writeText(
                                `${getUrl()}/homes/${property.slugShort}`
                              )
                              .then(() => {
                                setCopiedUrl(
                                  `${getUrl()}/homes/${property.slugShort}`
                                );
                                capture({
                                  category: "browse",
                                  event: "share_done",
                                  properties: property,
                                });
                              });
                          }}
                          className=" w-full rounded-md bg-zote-primary  px-4 py-2 font-medium text-white hover:bg-zote-primary"
                        >
                          Copy Link
                        </button>
                      )}
                    </div>
                  </div>
                </Dialog.Content>
              </Dialog.Portal>
            </Dialog.Root>
            <div className="absolute right-0 mr-2    hidden h-full flex-row items-center space-x-1 lg:flex lg:space-x-4">
              <div
                onClick={async () => {
                  if (!navigator.canShare) {
                    setShareModal(!shareModal);
                  } else {
                    try {
                      await navigator.share(shareData);

                      capture({
                        category: "browse",
                        event: "share_done",
                        properties: property,
                      });
                    } catch (err) {
                      console.log("Error: " + err);
                    }
                  }
                }}
                className="  flex cursor-pointer flex-row items-center space-x-2 rounded-md px-3 py-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-share-2"
                >
                  <circle cx="18" cy="5" r="3" />
                  <circle cx="6" cy="12" r="3" />
                  <circle cx="18" cy="19" r="3" />
                  <path d="M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98" />
                </svg>
                <span className=" text-xs lg:text-base">Share</span>
              </div>
              <div
                onClick={async () => {
                  if (!user) {
                    authModal.setOpen(true);
                    authModal.setActive(1);
                    authModal.setActionMode("SAVE");

                    capture({
                      category: "browse",
                      event: "favorite_click",
                    });
                    return;
                  }
                  if (user && claims.manager) {
                    capture({
                      type: "lister",
                      category: "browse",
                      event: "favorite_click",
                    });
                  }

                  await favoriteProperty(
                    user,
                    claims,
                    favorite,
                    setFavorite,
                    property,
                    "FIRESTORE"
                  );
                }}
                className={
                  "group flex flex-row items-center  space-x-2 rounded-md px-3 py-1 hover:shadow-sm" +
                  (user
                    ? "  " +
                      (claims.user
                        ? " cursor-pointer" +
                          (favorite ? " bg-red-100" : " hover:bg-red-100")
                        : "cursor-not-allowed")
                    : " cursor-pointer")
                }
              >
                {!favorite ? (
                  <AiOutlineHeart className="h-5 w-5 group-hover:text-red-600" />
                ) : (
                  <AiFillHeart className=" h-5 w-5 text-red-500 " />
                )}
                {!favorite ? (
                  <span className=" select-none text-xs font-medium group-hover:text-red-600 lg:text-base ">
                    Favorite
                  </span>
                ) : (
                  <span className="  select-none text-xs  font-medium text-red-600 lg:text-base ">
                    Favorite
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* 
        {views?.numberofviews > 0 ? ( // return back after sorting bigquery billing
          <div className=" flex flex-col space-y-2 lg:flex-row lg:items-center lg:space-x-2">
            <div className=" mt-2 flex  w-64 flex-col justify-center  rounded-md bg-blue-200 px-4 py-2">
             
              <div className=" flex flex-row items-center  space-x-4">
                <FaHouseUser />
                {loadingViews ? (
                  <span>... views in the past week</span>
                ) : (
                  <span>
                    
                    {views.numberofviews} views in the past week
                  </span>
                )}
              </div>
            </div>
            {views?.numberofviews > 4 || clicks > 0 ? (
              <>
                {property.listerName !== "Zote" ? ( // !== for prod
                  <>
                    {clicks > 0 ? (
                      <div className=" mt-2 flex  w-64 flex-col justify-center  rounded-md bg-green-200 px-4 py-2">
                        <div className=" flex flex-row items-center  space-x-4">
                          <FaWhatsapp />
                          <span>
                            {clicks} {clicks > 1 ? "inquiries" : "inquiry"} in
                            the past week
                          </span>
                        </div>
                      </div>
                    ) : null}
                  </>
                ) : (
                  <div className=" mt-2 flex  w-64 flex-col justify-center  rounded-md bg-green-200 px-4 py-2">
                    <div className=" flex flex-row items-center  space-x-4">
                      <FaWhatsapp />
                      {clicks > 0 ? (
                        <span>
                          {clicks} {clicks > 1 ? "inquiries" : "inquiry"} in the
                          past week
                        </span>
                      ) : (
                        <span>1 inquiry in the past week</span>
                      )}
                    </div>
                  </div>
                )}
              </>
            ) : null}
          </div>
        ) : null} */}

        <div className=" mb-0 mt-2 flex h-auto w-full flex-col lg:mt-4 lg:flex-row">
          <div className=" flex h-auto w-full flex-col space-y-2 divide-y divide-gray-300 pr-0 lg:w-2/3 lg:divide-y lg:divide-gray-200 lg:pr-20 ">
            <div className=" flex w-full flex-col py-2 lg:w-auto">
              <h2 className=" mb-1 text-lg font-semibold text-gray-900 lg:mb-2 lg:text-xl">
                Overview
              </h2>

              <div className="flex flex-col space-y-3 lg:space-y-5">
                <div className=" flex flex-col space-x-0  space-y-1 lg:space-y-2">
                  <div className=" flex flex-row items-center space-x-5">
                    <div className=" flex w-40 flex-row items-center space-x-3">
                      <BiBed className=" fill-current h-4 w-4 text-gray-700 lg:h-5 lg:w-5" />
                      <span className="">Bedrooms:</span>
                    </div>
                    <span className=" font-semibold">
                      {property.noOfBedrooms}
                    </span>
                  </div>

                  <div className=" flex flex-row items-center space-x-5">
                    <div className=" flex w-40 flex-row items-center space-x-3">
                      <BiBath className=" fill-current h-4 w-4 text-gray-700 lg:h-5 lg:w-5" />
                      <span className="">Bathrooms:</span>
                    </div>
                    <span className="   font-semibold">
                      {property.noOfBathrooms}
                    </span>
                  </div>
                  <div className=" flex flex-row items-center space-x-5">
                    <div className=" flex w-40 flex-row items-center space-x-3">
                      <MdOutlineVilla className=" fill-current h-4 w-4 text-gray-700 lg:h-5 lg:w-5" />
                      <span className="">Property type:</span>
                    </div>
                    <span className="   font-semibold">
                      {property.propertyType}
                    </span>
                  </div>

                  <div className=" flex flex-row items-center space-x-5">
                    <div className=" flex w-40 flex-row items-center space-x-3">
                      <MdOutlineSquareFoot className=" fill-current h-4 w-4 text-gray-700 lg:h-5 lg:w-5" />
                      <span className="">Property size:</span>
                    </div>
                    <span className="   font-semibold">
                      {property.squareFootage
                        ? property.squareFootage + " sqft"
                        : "-"}
                    </span>
                  </div>
                  {property.listingType === "RENT" ? (
                    <div className=" flex flex-row items-center space-x-5">
                      <div className=" flex w-40 flex-row items-center space-x-3">
                        <RiSecurePaymentLine className=" fill-current h-4 w-4 text-gray-700 lg:h-5 lg:w-5" />
                        <span className="">Security deposit:</span>
                      </div>
                      <span className="   font-semibold">
                        {property.securityDeposit
                          ? "Kshs " +
                            Intl.NumberFormat().format(property.securityDeposit)
                          : "Enquire"}
                      </span>
                    </div>
                  ) : null}
                </div>

                <div className=" mt-3 flex flex-col">
                  <h2 className=" mb-1 text-lg font-semibold text-gray-900 lg:mb-2 lg:text-xl ">
                    Description
                  </h2>
                  <h3 className=" mr-0 select-none text-base leading-relaxed text-gray-900 lg:mr-6">
                    {property.propertyDescription}
                  </h3>
                </div>
                <div>
                  <h2 className=" mb-2 text-lg font-semibold text-gray-900 lg:mb-2 lg:text-xl ">
                    Location
                  </h2>
                  <div className=" h-48 w-full  rounded-md border border-gray-200 lg:h-72">
                    <div style={{ height: "100%", width: "100%" }}>
                      <GoogleMap
                        apiKey={process.env.NEXT_PUBLIC_MAP_KEY}
                        defaultCenter={{
                          lat: property.addressHidden
                            ? obfuscateGeopoint(
                                property.propertyExactLocation.geoPoint
                                  ._latitude,
                                property.propertyExactLocation.geoPoint
                                  ._longitude
                              )[0]
                            : property.propertyExactLocation.geoPoint._latitude,
                          lng: property.addressHidden
                            ? obfuscateGeopoint(
                                property.propertyExactLocation.geoPoint
                                  ._latitude,
                                property.propertyExactLocation.geoPoint
                                  ._longitude
                              )[1]
                            : property.propertyExactLocation.geoPoint
                                ._longitude,
                        }}
                        defaultZoom={13}
                        onGoogleApiLoaded={onGoogleApiLoaded}
                        // onChange={(map) => console.log("Map moved", map)}
                      >
                        <PinComponent
                          key={property.objectID}
                          lat={
                            property.addressHidden
                              ? obfuscateGeopoint(
                                  property.propertyExactLocation.geoPoint
                                    ._latitude,
                                  property.propertyExactLocation.geoPoint
                                    ._longitude
                                )[0]
                              : property.propertyExactLocation.geoPoint
                                  ._latitude
                          }
                          lng={
                            property.addressHidden
                              ? obfuscateGeopoint(
                                  property.propertyExactLocation.geoPoint
                                    ._latitude,
                                  property.propertyExactLocation.geoPoint
                                    ._longitude
                                )[1]
                              : property.propertyExactLocation.geoPoint
                                  ._longitude
                          }
                          text={JSON.stringify(property)}
                          onClick={onMarkerClick}
                        />
                      </GoogleMap>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className=" h-auto pt-3 lg:pt-5 w-full lg:w-auto ">
					<span className=" font-semibold text-gray-900 text-base lg:text-xl">
						Bills
					</span>

					<div className=" flex flex-col pt-3 pb-4 space-y-1">
						<div className=" flex flex-row space-x-2 items-center">
							<ImPower className="h-4 w-4 stroke-current text-gray-900" />
							<span className="">Electricity - Prepaid token system</span>
						</div>
						<div className=" flex flex-row space-x-2 items-center">
							<IoIosWater className="h-4 w-4 stroke-current text-gray-900" />
							<span className=" ">Water - County allocated</span>
						</div>
					</div>
				</div> */}
            {/* 
				<div className=" h-auto pt-3 lg:pt-4 w-full lg:w-auto">
					<span className=" font-semibold text-gray-900 text-base lg:text-xl">
						Features
					</span>
					<div className="flex flex-col py-4 w-full">
						<div className="h-auto w-full grid lg:grid-flow-col grid-cols-2 lg:grid-cols-3 lg:grid-rows-5 gap-x-2 lg:gap-x-4 gap-y-2 lg:gap-y-3">
							<div className=" flex-shrink-0 h-auto w-full">
								<div className="flex flex-row items-center space-x-2">
									<div className=" rounded-full h-5 w-5 lg:h-6 lg:w-6 bg-green-100 flex items-center justify-center">
										<BiCheck className="lg:h-5 lg:w-5 h-4 w-4 stroke-current text-green-800" />
									</div>
									<span className=" text-gray-800">
										Open plan kitchen
									</span>
								</div>
							</div>

							<div className=" flex-shrink-0 h-auto w-full">
								<div className="flex flex-row items-center space-x-2">
									<div className=" rounded-full h-5 w-5 lg:h-6 lg:w-6 bg-green-100 flex items-center justify-center">
										<BiCheck className="lg:h-5 lg:w-5 h-4 w-4 stroke-current text-green-800" />
									</div>
									<span className=" text-gray-800">
										Open plan kitchen
									</span>
								</div>
							</div>
						</div>
					</div>
				</div> */}

            {Object.entries(amenities ?? {}).length != 0 ? (
              <div
                className={
                  "  h-auto w-full pt-3 lg:w-auto lg:pt-4 " +
                  (matching.length > 1 ? " pb-0" : " pb-5 lg:pb-8")
                }
              >
                <h2 className=" text-lg font-semibold text-gray-900 lg:text-xl">
                  Amenities
                </h2>
                <div className="flex w-full flex-col py-4">
                  <div className="grid h-auto w-auto grid-cols-2 gap-x-3 gap-y-3  leading-snug lg:grid-flow-col lg:grid-cols-3 lg:grid-rows-5 lg:gap-x-4 lg:gap-y-3">
                    {property.furnishing ? (
                      <div className="flex flex-row items-center space-x-0 rounded-md  bg-gray-150 px-4 py-3 lg:space-x-1 lg:py-4">
                        {/* <BsDot className="stroke-current h-6 w-6 text-gray-900" /> */}
                        <h3 className=" capitalize leading-4 text-gray-900">
                          {property.furnishing === "NOT-FURNISHED"
                            ? "Unfurnished"
                            : property.furnishing.toLowerCase()}
                        </h3>
                      </div>
                    ) : null}
                    {Object.entries(amenities).map((el) => {
                      return (
                        <div
                          key={el[0]}
                          className="flex flex-row items-center space-x-0 rounded-md  bg-gray-150 px-4 py-3 lg:space-x-1 lg:py-4"
                        >
                          {/* <BsDot className="stroke-current h-6 w-6 text-gray-900" /> */}
                          <h3 className=" leading-4 text-gray-900">
                            {el[1]?.name}
                          </h3>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            ) : null}

            <div className="flex  flex-col space-y-2 pt-3 lg:pt-4">
              <div className=" flex flex-col space-y-0">
                <h2 className=" mb-2 text-lg font-semibold text-gray-900 lg:mb-2 lg:text-xl ">
                  Explore the area
                </h2>
                {/* <div className=" flex flex-row    flex-wrap space-x-3 rounded-md bg-gray-200">
                  <div className=" flex flex-shrink-0 flex-row  space-x-2">
                    <span>Schools</span>
                    <span>Primary Schools</span>
                    <span> Secondary Schools</span>
                    <span>Universities/Colleges</span>
                  </div>
                  <span>Hospitals</span>
                  <span>Supermarkets and Malls</span>
                  <span>Gyms</span>
                </div> */}
              </div>

              {/* <div className=" h-64 w-full rounded-md  bg-gray-200"></div> */}
              <div className=" flex flex-col space-y-4 pb-5">
                <CollapsibleLocation
                  type="school"
                  key="school"
                  property={property}
                  nearby={nearby}
                  setNearby={setNearby}
                  titleThree={titleThree}
                  service={service}
                  distance={distance}
                  mapReady={mapReady}
                />

                <CollapsibleLocation
                  type="shopping"
                  key="shopping"
                  property={property}
                  nearby={nearby}
                  setNearby={setNearby}
                  titleThree={titleThree}
                  service={service}
                  distance={distance}
                  mapReady={mapReady}
                />
                <CollapsibleLocation
                  type="hospital"
                  key="hospital"
                  property={property}
                  nearby={nearby}
                  setNearby={setNearby}
                  titleThree={titleThree}
                  service={service}
                  distance={distance}
                  mapReady={mapReady}
                />
                <CollapsibleLocation
                  type="gym"
                  key="gym"
                  property={property}
                  nearby={nearby}
                  setNearby={setNearby}
                  titleThree={titleThree}
                  service={service}
                  distance={distance}
                  mapReady={mapReady}
                />
              </div>
            </div>
          </div>

          {!propertyChatVisible ? (
            <div className=" z-10 flex   w-full flex-col items-center space-y-0 px-0  py-0 lg:sticky lg:top-20 lg:z-0 lg:h-48 lg:w-96 lg:space-y-4 lg:px-2 lg:py-4  ">
              <div className=" fixed bottom-0 flex  h-auto w-full  flex-col justify-center space-y-2 rounded-none  border   border-gray-200 bg-white px-3 py-4  shadow-xl lg:relative lg:h-56 lg:rounded-md lg:px-8 lg:py-6 lg:shadow">
                <div className=" flex flex-row items-center space-x-2">
                  <div className=" flex h-8 w-8 items-center justify-center rounded-full border border-white bg-blue-50  shadow-sm lg:h-10 lg:w-10">
                    {lister?.auth?.photo ? (
                      <Link
                        href={`/${lister.listerInfo.listerUserName}`}
                        passHref
                      >
                        <a
                          onClick={() => {
                            capture({
                              category: "browse",
                              event: "lister_click",
                              properties: property,
                            });

                            router.push(`/${lister.listerInfo.listerUserName}`);
                          }}
                          className=" bg-zote-primary-100 relative flex h-full w-full flex-shrink-0 items-center justify-center rounded-full border border-gray-300 shadow"
                        >
                          <Image
                            src={
                              lister?.auth?.photo != undefined
                                ? lister?.auth?.photo
                                : ""
                            }
                            unoptimized
                            alt={lister?.listerInfo?.listerName}
                            className=" h-full w-full cursor-pointer rounded-full object-cover"
                            priority
                            layout="fill"
                          />
                        </a>
                      </Link>
                    ) : (
                      <Link
                        href={`/${lister.listerInfo.listerUserName}`}
                        passHref
                        className=" flex h-5 w-5 flex-shrink-0 cursor-pointer items-center  justify-center rounded-full bg-blue-50"
                      >
                        <a>
                          <CgProfile
                            onClick={() => {
                              capture({
                                category: "browse",
                                event: "lister_click",
                                properties: property,
                              });

                              router.push(
                                `/${lister.listerInfo.listerUserName}`
                              );
                            }}
                            className="  h-full w-full text-zote-secondary"
                          />
                        </a>
                      </Link>
                    )}
                  </div>
                  <div className=" flex flex-row  items-center space-x-1">
                    <Link
                      href={`/${lister.listerInfo.listerUserName}`}
                      className=" lg:text-md cursor-pointer text-base font-medium text-gray-900 lg:text-gray-900"
                      passHref
                    >
                      <a>
                        {/* <h2 className="hidden">
                          Listed By{" "}
                          {lister.listerInfo.listerType === "INDIVIDUAL_AGENT"
                            ? "Agent"
                            : "Company"}
                        </h2> */}
                        <h3
                          className=" cursor-pointer"
                          onClick={() => {
                            capture({
                              category: "browse",
                              event: "lister_click",
                              properties: property,
                            });

                            router.push(`/${lister.listerInfo.listerUserName}`);
                          }}
                        >
                          {lister.listerInfo.listerName}
                        </h3>
                      </a>
                    </Link>

                    {/* <FaCheckCircle className="stroke-current text-blue-500 h-3 w-3" /> */}
                  </div>
                </div>

                <div className="  flex flex-row space-x-3">
                  <div
                    onClick={() => {
                      if (!user) {
                        authModal.setOpen(true);
                        authModal.setActive(1);
                        authModal.setActionMode("MESSAGE");

                        capture({
                          category: "lead",
                          event: "chat_click",
                          properties: property,
                        });
                        return;
                      }
                      if (user && claims.manager) {
                        capture({
                          type: "lister",
                          category: "lead",
                          event: "chat_click",
                          properties: property,
                        });
                        return;
                      }
                      if (user && claims.user) {
                        setPropertyChatVisible(!propertyChatVisible);
                      }
                    }}
                    className={
                      " relative flex h-12  w-12 flex-shrink-0 items-center justify-center rounded-md   bg-zote-primary-background" +
                      (user
                        ? " " +
                          (claims.user
                            ? " cursor-pointer"
                            : "cursor-not-allowed")
                        : " cursor-pointer")
                    }
                  >
                    <PiChats className=" h-6 w-6   text-zote-secondary" />
                    {unread > 0 ? (
                      <span className=" absolute bottom-8 left-8 flex h-5 w-5 items-center justify-center rounded-full bg-pink-600 text-xs font-medium text-white">
                        {unread}
                      </span>
                    ) : null}
                  </div>

                  {/* <a
                    onClick={(e) => {
                      if (!user) {
                        e.preventDefault();
                        authModal.setOpen(true);
                        authModal.setActive(0);
                        authModal.setActionMode("");

                        capture({
                          category: "lead",
                          event: "contact_click",
                          properties: {
                            ...property,
                            type: "property",
                          },
                        });
                        return;
                      }
                      if (user && claims.manager) {
                        e.preventDefault();
                        capture({
                          type: "lister",
                          category: "lead",
                          event: "contact_click",
                          properties: {
                            ...property,
                            type: "property",
                          },
                        });
                        return;
                      }
                      capture({
                        category: "lead",
                        event: "lead_deliver",
                        properties: property,
                      });
                      capture({
                        category: "lead",
                        event: "contact_done",
                        properties: property,
                      });
                    }}
                    href={`tel:+254${lister.listerInfo.listerPhone}`}
                    className=" flex w-full select-none flex-row items-center justify-center space-x-1 rounded  bg-zote-primary-background px-6 py-3 text-base  font-semibold  text-zote-secondary "
                  >
                    <IoIosCall className=" h-5 w-5" />
                    <span>Contact</span>
                  </a> */}

                  <a
                    onClick={(e) => {
                      if (user && claims.manager) {
                        e.preventDefault();
                        capture({
                          type: "lister",
                          category: "lead",
                          event: "whatsapp_click",
                          properties: property,
                        });
                        return;
                      }
                      capture({
                        category: "lead",
                        event: "whatsapp_click",
                        properties: property,
                      });
                    }}
                    href={whatsappUrl}
                    rel="nofollow noreferrer"
                    className=" text-gray-50 flex w-full cursor-pointer select-none flex-row items-center justify-center space-x-1 rounded bg-[#23d366] px-4 py-3 text-base font-medium "
                  >
                    <BiLogoWhatsapp className=" h-6 w-6 text-gray-100 " />

                    <span className=" font-semibold text-gray-100">
                      Whatsapp
                    </span>
                  </a>
                </div>
              </div>
            </div>
          ) : null}
        </div>

        {matching.length > 1 ? (
          <div className="mb-12 flex flex-col  space-y-3 px-0 py-2 lg:flex-col lg:space-y-4 lg:px-0 lg:py-10">
            <div className=" flex flex-row  items-center justify-between">
              <h2 className="   text-lg font-semibold lg:text-2xl  ">
                Other similar homes that might interest you
              </h2>

              {matching.length === 4 ? (
                <Link
                  href={{
                    pathname: `/town/${property.propertyTown.townSlug}`,
                  }}
                  key={property.propertyTown.townSlug}
                  as={`/town/${property.propertyTown.townSlug}`}
                  passHref
                >
                  <a className=" hidden cursor-pointer text-sm font-semibold text-zote-primary hover:underline  lg:flex lg:text-base">
                    <h3>See more</h3>
                  </a>
                </Link>
              ) : null}
            </div>
            <div className="flex w-full   snap-x flex-col gap-y-5 lg:grid lg:h-[17rem] lg:grid-cols-4   lg:gap-x-5 lg:overflow-x-auto">
              {matching.map((hit) => {
                return (
                  <HomePropertyHit
                    key={hit.propertyID}
                    hit={hit}
                    loadingProperty={loadingProperty}
                    setLoadingProperty={setLoadingProperty}
                    dataSource="FIRESTORE"
                    pageSource="PROPERTY"
                  />
                );
              })}

              <div
                className={
                  " h-full items-center justify-start " +
                  (matching.length < 4
                    ? " ml-0 flex lg:flex  "
                    : "  flex lg:hidden")
                }
              >
                <Link
                  href={{
                    pathname: `/town/${property.propertyTown.townSlug}`,
                  }}
                  as={`/town/${property.propertyTown.townSlug}`}
                  passHref
                >
                  <a className=" cursor-pointer text-sm font-semibold  text-zote-primary hover:underline  lg:text-base">
                    <h3>
                      See more apartments and houses for{" "}
                      {property.listingType.toLowerCase()} in{" "}
                      {property.propertyTown.townName}
                    </h3>
                  </a>
                </Link>
              </div>
            </div>
          </div>
        ) : null}
      </div>

      {propertyChatVisible ? (
        <UserPropertyChat
          lister={lister}
          property={property}
          propertyID={property.propertyID}
          setPropertyChatVisible={setPropertyChatVisible}
        />
      ) : null}
    </>
  );
}

export default Property;
